// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom'; // Link is already imported, good!

const LICENSED_STATES = [
    'OH', 'FL', 'NJ', 'NY', 'PA', 'IN', 'CO', 'IA', 'IL', 'VA',
    'WV', 'TN', 'CT', 'MI', 'AZ', 'LA', 'WY', 'OR',
    'KS', 'DC', 'MA'
];

export default function Footer() {
    return (
        <footer className="site-footer">

            {/* --- Add the Navigation Links Here --- */}
            <nav className="footer-nav"> {/* Added a nav element with a class for styling */}
                <Link to="/terms" className="footer-link">Terms of Use</Link>
                {' | '} {/* Separator between links */}
                <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                {' | '} {/* Separator */}
                <Link to="/contact" className="footer-link">Contact Us</Link>
            </nav>
            {/* ------------------------------------ */}

            <p className="disclaimer">
                Disclaimer: All content on <strong>BoostYourBets.com</strong> is for entertainment purposes only. The information we provide is to help you make better decisions. You must be 21 or older to use this site.
            </p>
            <p className="responsible-gaming">
                If you or someone you know has a gambling problem, crisis counseling and referral services can be accessed by calling <a href="tel:1-800-GAMBLER">1-800-GAMBLER</a>.
            </p>
             <p className="licensed">
                 Compliant with regulations in these states: {LICENSED_STATES.join(', ')}.
             </p>
            <p className="copyright">
                &copy; {new Date().getFullYear()} BoostYourBets LLC. All rights reserved.
            </p>
        </footer>
    );
}